module.exports = __webpack_public_path__ + "a47013ac7a39f01f50ed9d18db77987c.png";